import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";
import { useNav } from "@/contexts/NavigationContext";

/** Flechas "Anterior / Siguiente": misma ubicación en todo el ERP (encabezado). En procesos de varios
 *  pasos recorren los pasos; en el resto, las vistas visitadas. Teclado: Tab + Enter o Alt + ← / →. */
export default function NavArrows() {
  const nav = useNav();
  if (!nav) return null;
  const { canPrev, canNext, prev, next, steps } = nav;
  const btn = "inline-flex items-center gap-1 h-9 px-2 sm:px-2.5 rounded-md border border-border text-xs font-medium "
    + "text-text-secondary hover:text-agro-green hover:border-agro-green/50 disabled:opacity-35 disabled:hover:text-text-secondary "
    + "disabled:hover:border-border disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-2 focus-visible:outline-agro-green";
  const ctx = steps ? ` (${steps.label || "paso"} ${steps.index + 1} de ${steps.total})` : "";
  return (
    <nav className="flex items-center gap-1 flex-shrink-0" aria-label="Navegación anterior y siguiente" data-testid="nav-arrows">
      <button type="button" onClick={prev} disabled={!canPrev} data-testid="nav-prev"
        aria-label={`Anterior${ctx}`} title={`Anterior${ctx} · Alt + ←`} className={btn}>
        <CaretLeftIcon size={14} weight="bold" /><span>Anterior</span>
      </button>
      <button type="button" onClick={next} disabled={!canNext} data-testid="nav-next"
        aria-label={`Siguiente${ctx}`} title={`Siguiente${ctx} · Alt + →`} className={btn}>
        <span>Siguiente</span><CaretRightIcon size={14} weight="bold" />
      </button>
      {steps && <span className="text-[10px] text-text-muted ml-1" data-testid="nav-step">
        {steps.label || "Paso"} {steps.index + 1}/{steps.total}</span>}
      {/* Los procesos de varios pasos suelen abrirse en un diálogo: las mismas flechas quedan
          disponibles sobre él (abajo, al centro) mientras el proceso esté abierto */}
      {steps && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] flex items-center gap-2 bg-card/95 border border-border rounded-full px-2 py-1.5 shadow-2xl"
             data-testid="nav-steps-float" aria-label="Pasos del proceso">
          <button type="button" onClick={prev} disabled={!canPrev} data-testid="nav-step-prev" aria-label={`Anterior${ctx}`} className={btn}>
            <CaretLeftIcon size={14} weight="bold" /><span>Anterior</span>
          </button>
          <span className="text-[11px] text-text-secondary px-1">{steps.label || "Paso"} {steps.index + 1} de {steps.total}</span>
          <button type="button" onClick={next} disabled={!canNext} data-testid="nav-step-next" aria-label={`Siguiente${ctx}`} className={btn}>
            <span>Siguiente</span><CaretRightIcon size={14} weight="bold" />
          </button>
        </div>
      )}
    </nav>
  );
}
